export default __webpack_public_path__ + "static/media/hexWithComb.a9d2a8ff.jpg";